import { ValidPasswordRegex } from "../../utils";
import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

const CONTROL_NAME = "createPassword";
export const passwordFieldValidator = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams<string>) => {
  return new Promise((resolve, reject) => {
    const [_, value, _defs, schema] = args;
    const { instancePath = "" } = schema;
    const paths = instancePath.split("/");
    const name = paths[paths.length - 1];

    const checkValidated = () => {
      if (onValidated) {
        onValidated(names, name, CONTROL_NAME, []);
      }
    };
    const checkInvalid = (errorCode = 0) => {
      if (onInvalid) {
        onInvalid(names, name, CONTROL_NAME, errorCode, []);
      }
    };

    if (onValidationStarted) {
      onValidationStarted(CONTROL_NAME, name);
    }
    try {
      const regex = new RegExp(ValidPasswordRegex);
      const isValueValid = regex.test(value);
      if (!isValueValid) {
        checkInvalid(0);
        return reject(
          validationException("passwordValidator", "Invalid Password"),
        );
      }
      checkValidated();
      return resolve(true);
    } catch (e) {
      checkInvalid(500);
      reject(validationException("passwordValidator", "Invalid Password"));
    }
  });
};
